import React from 'react';
import BlogCard from './BlogCard';

const BlogGrid = ({ blogs }) => {
  return (
    <section className="mt-6 rounded-[30px] border border-gray-100 bg-white p-5 shadow-sm sm:p-6">
      <div className="mb-5 flex items-center justify-between gap-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#9a51a0]">
            All Articles
          </p>
          <h3 className="mt-2 text-2xl font-bold text-[#20192d]">Blog Collection</h3>
        </div>
        <div className="hidden rounded-2xl bg-gray-50 px-4 py-2 text-sm font-medium text-slate-500 sm:block">
          {blogs.length} posts
        </div>
      </div>
      <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
        {blogs.map((blog) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </div>
    </section>
  );
};

export default BlogGrid;
